module.exports = function() {
    // global functionality goes here

    const $body = $('body'),
        $masthead = $('.masthead'),
        $stickyHeader = $('.masthead__bottom'),
        $stickyHeaderMobile = $('.masthead__top');

    $body.addClass('jsenabled');


    // check if browser is IE - if true, add body class
    const isIE = navigator.appName === 'Microsoft Internet Explorer' ||
        !!(navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)) ||
        (typeof $.browser !== "undefined" && $.browser.msie === 1);

    if (isIE) {
        $body.addClass('browser-ie');
    }


    // push gtm-event data-values on anchors to datalayer
    $body.on( 'click', '[data-gtm-event]', function() {
        let gtm_event = $(this).data('gtm-event');
        let page_url = $(location).attr('href');

        // console.log({'dbk_category' : 'click_event', 'dbk_event' : gtm_event, 'dbk_url' : page_url }); // development

        if ( typeof dataLayer !== 'undefined' ) {
            dataLayer.push({'dbk_category': 'click_event', 'dbk_event': gtm_event, 'dbk_url': page_url}); // production
        }
    });


    // prevent disabled buttons to execute default actions
    $('.btn-disabled').click( function(e) {
        e.preventDefault();
    });


    // unfocus links after click
    $body.on('click', 'a, button', function () {
        $(this).blur();
    });

    // init tooltips
    $body.tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body'
    });

    // init popovers
    $body.popover({
        // trigger: 'click',
        selector: '[data-toggle="popover"]',
        trigger: 'hover',
        html: true,
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    });


    // toggle-menu
    $('#toggle-menu').click( function(e) {
        e.preventDefault();
        if ( $body.hasClass('show-menu') ) {
            $body.removeClass('show-menu');
        } else {
            $body.addClass('show-menu');

            if ($(window).scrollTop() < $masthead.offset().top) {
                $('html, body').animate({
                    scrollTop: $masthead.stop().offset().top
                }, 300, 'easeOutCubic');
            }
        }
    });
    // close menu
    $('#close-mobile-nav').click( function(e) {
        e.preventDefault();
        if ( $body.hasClass('show-menu') ) {
            $body.removeClass('show-menu');
        }
    });


    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $('body').on('click', 'a[href^="#"]', function(e) {
        e.preventDefault();
        let $this = $(this);
        let target = $(this).attr('href');
        let scrollOffset = $stickyHeader.outerHeight();

        if (viewport().width < 1201) {
            scrollOffset = $stickyHeaderMobile.outerHeight();
        }

        if ($this.data('extra-scroll-offset')) {
             scrollOffset = scrollOffset + $(this).data('extra-scroll-offset');
        }

        if ($this.closest('.sticky-page-nav').length > 0) {
            scrollOffset = scrollOffset + $(this).closest('.sticky-page-nav').outerHeight();
        }

        // if target exists
        if ( $(target).length > 0 ) {

            // if target has top margin, add half of it to scroll offset
            let targetMargin = parseInt($(target).css('marginTop'));

            if (targetMargin > 0) {
                scrollOffset = scrollOffset + (targetMargin / 2);
            }

            $('html, body').animate({
                scrollTop: $(target).stop().offset().top - scrollOffset
            }, 1000, 'easeInOutCubic', function() {
                $this.blur();
            });
        }
    });


    // disable hero-video with URL variable
    if ( window.location.search.indexOf('no_video=1') >= 0 ) {
        $('section.hero .hero__background-video').hide();
    }


    // insert check icon elements to ul.list-checked in content-wrapper
    $('.content-wrapper .list-checked > li').each( function() {
        $(this).prepend('<i class="item-icon far fa-check"></i>');
    });


    // insert dropdown icon elements to menu items with sub-items in masthead menu
    $('.masthead__nav li.menu-item-has-children > a').each( function() {
        $(this).append('<i class="item-icon fas fa-caret-down"></i>');
    });


    $('.sub-menu-toggle').on('click', function (e) {
        e.preventDefault();

        let $submenu = $(this).closest('.menu-item').find('.sub-menu');

        if ($(this).hasClass('sub-menu-toggle--toggled')) {
            $submenu.stop().slideUp(300).animate({opacity: 0}, {queue: false, duration: 300});
            $(this).removeClass('sub-menu-toggle--toggled');
        } else {
            $(this).addClass('sub-menu-toggle--toggled');
            $submenu.stop().css('opacity', 0).slideDown(300).animate({opacity: 1}, {queue: false, duration: 300});
        }
    });


    // load extra JS parts
    require('./gravity-forms');
    require('./notification-bar');
    require('./sticky-masthead');
    require('./sliders');
    require('./fancy-video');
    require('./fancybox');
    require('./filters');
    require('./tabs'); 
    require('./expandable-items'); 
    require('./responsive-video'); 
    require('./html-videos');
    require('./popups');
    require('./sortable-table'); 
    require('./search-form');
    require('./dbk-cookie-law');
    require('./copy-to-clipboard'); 
    require('./popins');
    require('./anchors-missing-title');
    require('./table-of-contents');

};